import * as type from "../types";

const initialState = {
  list: [],
  loading: false,
  commintmentStatusLoading: false,
  error: false,
  updateError: false,
  updateParametersCompleted: false,
};

export default function organizations(state = initialState, action) {
  switch (action.type) {
    case type.ORGANIZATION_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.ORGANIZATION_SEARCH_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.ORGANIZATION_SEARCH_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.ORGANIZATION_FIND_BY_TERM_SEARCH_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.ORGANIZATION_FIND_BY_TERM_SEARCH_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.ORGANIZATION_SELECT:
      return {
        ...state,
        selectedOrganization: action.payload,
      };
    case type.GET_ORGANIZATION_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_ORGANIZATION_SUCCEEDED:
      return {
        ...state,
        selectedOrganization: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_ORGANIZATION_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_USER_LIMITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        updateParametersCompleted: false,
        customError: null,
      };
    case type.GET_USER_LIMITS_SUCCEEDED:
      return {
        ...state,
        loggedInOrganization: action.payload,
        loading: false,
        error: false,
        updateParametersCompleted: false,
        customError: null,
        updateError: false,
      };
    case type.GET_USER_LIMITS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_USERS_LIMITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        updateError: false,
        updateParametersCompleted: false,
      };
    case type.GET_USERS_LIMITS_SUCCEEDED:
      return {
        ...state,
        usersParamaterList: action.payload,
        loading: false,
        error: false,
        // updateParametersCompleted: false,
      };
    case type.GET_USERS_LIMITS_FAILED:
      return {
        usersParamaterList: [],
        ...state,
        loading: false,
        error: true,
      };

    case type.UPDATE_USER_LIMITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        updateError: false,
        updateParametersCompleted: false,
        customError: null,
      };
    case type.UPDATE_USER_LIMITS_SUCCEEDED:
      return {
        ...state,
        succesMessage: action?.payload,
        loading: false,
        error: false,
        updateError: false,
        updateParametersCompleted: true,
        customError: null,
      };
    case type.UPDATE_USER_LIMITS_FAILED:
      return {
        ...state,
        loading: false,
        // error: true,
        updateError: true,
        customError: action?.payload,
        updateParametersCompleted: false,
      };
    case type.UPDATE_ORGANIZATION_LIMITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        updateError: false,
        updateParametersCompleted: false,
        customError: null,
      };
    case type.UPDATE_ORGANIZATION_LIMITS_SUCCEEDED:
      return {
        ...state,
        succesMessage: action?.payload,
        loading: false,
        error: false,
        updateError: false,
        updateParametersCompleted: true,
        customError: null,
      };
    case type.UPDATE_ORGANIZATION_LIMITS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        updateError: true,
        customError: action?.payload,
        updateParametersCompleted: false,
      };

    case type.GET_REGISTRATION_GENERAL_STATUS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case type.GET_REGISTRATION_GENERAL_STATUS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        error: false,
        registrationGeneralStatus: action?.payload,
      };

    case type.GET_REGISTRATION_GENERAL_STATUS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case type.GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case type.GET_REGISTRATION_PARTICIPANT_STATUS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        error: false,
        totalPageCount: action.payload.totalPageCount,
        totalItemCount: action.payload.totalItemCount,
        // documentCount: {
        //   totalCount: action.payload.documentCount.totalCount,
        //   countInPage: action.payload.documentCount.countInPage,
        // },
        // blockedDocumentCount: {
        //   totalCount: action.payload.blockedDocumentCount.totalCount,
        //   countInPage: action.payload.blockedDocumentCount.countInPage,
        // },
        registrationParticipantStatusList: action?.payload?.items,
      };

    case type.GET_REGISTRATION_PARTICIPANT_STATUS_FAILED:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        error: false,
        registrationGeneralCommitmentStatus: action?.payload,
      };

    case type.GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case type.GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED:
      return {
        ...state,
        commintmentStatusLoading: true,
        error: false,
      };

    case type.GET_REGISTRATION_COMMITMENT_STATUS_SUCCEEDED:
      return {
        ...state,
        commintmentStatusLoading: false,
        error: false,
        totalItemCount: action?.payload?.totalItemCount,
        totalPageCount: action?.payload?.totalPageCount,
        registrationCommitmentStatusList: action.payload?.items,
      };

    case type.GET_REGISTRATION_COMMITMENT_STATUS_FAILED:
      return {
        ...state,
        error: true,
        commintmentStatusLoading: false,
      };
    default:
      return state;
  }
}
